var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldShowCountdown)?_c('div',{staticClass:"price-change-countdown"},[_vm._v("\n  "+_vm._s(_vm.$t('components.films.priceChangeCountdown.priceEndsIn[0]', {
      duration: _vm.countdownTimeRemaining,
      name: _vm.priceName,
    }))+"\n  "),_c('span',{staticClass:"g-text-primary"},[_vm._v("\n    "+_vm._s(_vm.$t('components.films.priceChangeCountdown.priceEndsIn[1]', {
        duration: _vm.countdownTimeRemaining,
        name: _vm.priceName,
      }))+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }